
const DownloadPluginLabel = () => (
    <>
        Download Macropay plugin
    </>
);

export default DownloadPluginLabel;
